import React from 'react';
import PropTypes from 'prop-types';

import ActionStateBannerStyleButton from '../../../components/ActionStateBannerStyleButton';

import { Body2, Heading6 } from '../../../components/Typography';

import './index.scss';

const FoodJournalTab = ({ data }) => {
  const { foodJournalTab } = data.uiData;
  return (
    <div className='food-journal-tab'>
      <div className='food-journal-tab__text-wrapper'>
        <Heading6>{foodJournalTab.title}</Heading6>
        <Body2>{foodJournalTab.text}</Body2>
      </div>

      <ActionStateBannerStyleButton
        title={foodJournalTab.buttonData.label}
        subtitle={foodJournalTab.buttonData.text}
        imageUrl={foodJournalTab.buttonData.imageUrl}
        imageAlt={foodJournalTab.buttonData.imageAlt}
        url={foodJournalTab.buttonData.url}
        actionState={foodJournalTab.buttonData.state}
      />
    </div>
  );
};

FoodJournalTab.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FoodJournalTab;
